import styled from '@emotion/styled'

export const Container = styled.div`
  padding-top: 14px;
`
